import { AuthUser } from "../../../api/common";

// Props interface
export interface LoginProps {
	setLoggedIn: (user: AuthUser) => void;
}

// Form state interface
export interface LoginState {
	username: string;
	password: string;
	loading: boolean;
	emailError: string;
	passwordError: string;
	error: string;
}

// Credentials interface
export interface LoginCredentials {
	username: string;
	password: string;
}

// Form errors interface
export interface LoginFormErrors {
	emailError: string;
	passwordError: string;
	error: string;
}

// Email validation pattern
export const EMAIL_PATTERN = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

export interface LoginViewModel {
	// State
	username: string;
	password: string;
	loading: boolean;
	emailError: string;
	passwordError: string;
	error: string;

	// Handlers
	handleEmailChange: (event: { target: { value: React.SetStateAction<string> } }) => void;
	handlePasswordChange: (event: { target: { value: React.SetStateAction<string> } }) => void;
	handleSubmit: (event: { preventDefault: () => void }) => Promise<void>;
	navigateToRegister: () => void;
	navigateToForgotPassword: () => void;

	// Computed
	isSubmitDisabled: boolean;
}
